// Fecha en formato YYYY-MM-DD usando la fecha LOCAL del cliente.
//
// NO usar `Date.prototype.toISOString().slice(0, 10)` para esto: toISOString()
// devuelve la fecha en UTC, así que en zonas con offset negativo (CST/Tilatina,
// UTC-6) después de las ~18:00 la fecha UTC ya es la del día siguiente. Eso hacía
// que el atajo "Hoy" del ECC resolviera a mañana y la consulta de CDR saliera con
// 0 llamadas (incidente 2026-06-22). Usar getFullYear/getMonth/getDate (locales)
// mantiene la fecha del calendario del usuario.
export function toLocalIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
